// src/components/Form.jsx
import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import './form.css';
import Input from '../../../Elements/Inputs/Input';
import Button from '../../../Elements/Buttons/Button';
import useForm from '../../../Hooks/UseForm';
import { setErrorFormSimpleUtil } from '../../../Utilities/Forms/errors';
import { COTIZACION_FORM } from '../../../Constants/Forms/Cotizacion';
import { cotizacionSchema } from '../../../Models/Forms/cotizacionSchema';
import { footerData } from '../../../../json/layout/footer';
import { contactoData } from '../../../../json/sections/Contact/contactData';
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaFacebookF,
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaTiktok,
} from "react-icons/fa";

const Form = () => {
    const [isClient, setIsClient] = useState(false);
    const [loading, setLoading] = useState(false);

    // Form state & validation
    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        isValid,
        resetForm,
    } = useForm(COTIZACION_FORM, cotizacionSchema);

    // Dinámico: placeholders + botón desde footerData
    const { footerCotizacion, alertas } = footerData;
    const fields = footerCotizacion.footerCotizacionData;
    const buttonText = footerCotizacion.botonTexto;
    // const formTitle = footerCotizacion.tituloPrincipal;

    // Datos de contacto
    const dataContacto = contactoData.ES;

    // Iconos sociales para contacto
    const iconMap = {
        FaMapMarkerAlt,
        FaPhoneAlt,
        FaEnvelope,
        FaFacebookF,
        FaInstagram,
        FaYoutube,
        FaTiktok,
        FaLinkedinIn,
    };

    useEffect(() => {
        setIsClient(true);
    }, []);
    if (!isClient) return null;

    const handleSubmit = async vals => {
        if (loading) return;
        setLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE}/send-mail`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(vals),
                }
            );
            const result = await response.json();
            if (response.ok) {
                resetForm();
                await Swal.fire({
                    icon: "success",
                    title: alertas.alertaSuccess.titulo,
                    text: alertas.alertaSuccess.texto,
                    confirmButtonColor: alertas.alertaSuccess.colorBoton,
                    confirmButtonText: alertas.alertaSuccess.textoBoton
                });
            } else {
                await Swal.fire({
                    icon: "error",
                    title: alertas.alertaError.titulo,
                    text: result.message || alertas.alertaError.texto,
                    confirmButtonColor: alertas.alertaError.colorBoton,
                    confirmButtonText: alertas.alertaError.textoBoton
                });
            }
        } catch {
            await Swal.fire({
                icon: "error",
                title: "Error de conexión",
                text: "No pudimos conectar con el servidor.",
                confirmButtonColor: "#d33",
                confirmButtonText: "Cerrar"
            });
        } finally {
            setLoading(false);
        }
    };
    // Clave de cada campo según tu formulario
    const formKeys = [
        "name",
        "email",
        "phone",
        "serviceType",
        "address",
        "message"
    ];

    return (
        <div className="container contact-container">
            <div className="row justify-content-center">

                {/* ====================== */}
                {/*   SECCIÓN CONTACTO   */}
                {/* ====================== */}
                <div className="col-md-6 contact-block">
                    <h1>CONTACT US!</h1>
                    <div className="info-line casper-normal">
                        <span className="text">{dataContacto.direccion}</span>
                    </div>
                    <div className="info-line casper-normal">
                        <a href={`tel:${dataContacto.telefono}`} className="text">
                            {dataContacto.telefono}
                        </a>
                    </div>
                    <div className="info-line casper-normal">
                        <a href={`mailto:${dataContacto.email}`} className="text">
                            {dataContacto.email}
                        </a>
                    </div>
                    <h3 className="follow-title">
                        {dataContacto.titulos.siguen}
                    </h3>
                    <div className="content-socials">
                        {dataContacto.redesSociales.map((social, idx) => {
                            const Icon = iconMap[social.icono];
                            return (
                                <a
                                    key={idx}
                                    href={social.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={`icon ${social.plataforma}`}
                                >
                                    {Icon && <Icon />}
                                </a>
                            );
                        })}
                    </div>
                </div>
                {/* ====================== */}
                {/*    SECCIÓN COTIZA     */}
                {/* ====================== */}
                <div className="col-md-6">
                    <div className="form-wrapper">
                        {/* <h3 dangerouslySetInnerHTML={{ __html: formTitle }} /> */}
                        {fields.map((f, i) => {
                            const key = formKeys[i];
                            const variant = key === "message" ? "Textarea" : "Simple";
                            return (
                                <Input
                                    key={i}
                                    placeholder={f.formText}
                                    variant={variant}
                                    value={values[key]}
                                    onChange={handleChange(key)}
                                    onBlur={handleBlur(key)}
                                    error={setErrorFormSimpleUtil(errors, touched, key)}
                                    success={!setErrorFormSimpleUtil(errors, touched, key)}
                                />
                            );
                        })}
                        <Button
                            text={loading ? "Sending..." : buttonText}
                            action={() => handleSubmit(values)}
                            disabled={!isValid || loading}
                            fill
                            color="red"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Form;
